<template>
    <div class="crew-change-history-card">
        <div
            v-for="(history, idx) in histories"
            :key="idx"
             class="crew-change-history-row"
        >
            <div>{{ formatDate(history.created_at) }}</div>
            <div>{{ history.detail }}</div>
            <div v-if="history.update_account_name">({{ history.update_account_name }})</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        histories: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return "";
            const d = new Date(dateStr);
            return `${d.getFullYear()}/${(d.getMonth()+1).toString().padStart(2, "0")}/${d.getDate().toString().padStart(2, "0")} ${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`;
        }
    }
};
</script>

<style scoped>
.crew-change-history-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 16px 16px 20px;
    font-weight: 600;
}
.crew-change-history-row {
    display: flex;
    gap: 10px;
}
</style>